<template>
    <div class="document-fallback d-flex flex-column align-items-center justify-content-center">
        <h3 class="flex-shrink">Unable to preview this file</h3>
        <button class="btn btn-primary btn-lg lex-shrink" @click="doDownload($event, item)">
            <i class="fas fa-download"></i>
            Download
            <small>({{ formatBytes(item.file.size) }})</small>
        </button>
    </div>
</template>

<script>
import { formatBytes } from 'ca-js-helper';

// mixins
import download from '@/components/media/mixins/download';

export default {
    name: 'DocumentFallback',
    mixins: [download],
    props: {
        item: {
            type: Object,
            required: true,
        }
    },
    methods: {
        formatBytes,
    }
}
</script>

<style lang="scss" scoped>
.document-fallback {
    width: 100%;
    height: 100%;
}
</style>
